<template>
  <div>
    <avatar-selection/>
    <section class="profile__block settings_pad pattern_scaled">
      <div class="profile__block__header">
        <h2>{{ getTranslations.home_settings_game_settings }}</h2>
      </div>
      <div class="settings__content">
        <settings-group :title="getTranslations.home_settings_account_settings"
                        @select="onSelect"
                        :options="[
                          { name: getTranslations.home_modals_change_username_title, id: actions.CHANGE_USERNAME, type: types.TEXT, styleClass: 'icon' },
                          { name: getTranslations.home_modals_change_login_pin_text, id: actions.CHANGE_PIN, type: types.TEXT, styleClass: 'icon' },
                          { name: getTranslations.home_modals_submit_email_text, id: actions.EMAIL, type: types.TEXT, styleClass: 'icon', innerClass : userDetails.hasEmailVerified ? 'deactivated' : '' },
                          { name: getTranslations.home_settings_public_profile, id: actions.TOGGLE_VISIBILITY, type: types.CHECKBOX, styleClass: '', value: !userDetails.hasPrivateProfile, }
                         ].filter(item => isEligibleForPinChange() || item.id !== actions.CHANGE_PIN )"/>
        <settings-group :title="getTranslations.home_settings_game_settings"
                        @select="onSelect"
                        :options="[
                          { name: getTranslations.home_settings_language, id: actions.TOGGLE_LANG, type: types.SELECT, styleClass: 'lang', options: localesMappedWithIndices },
                          { name: getTranslations.home_settings_sound_music, id: actions.TOGGLE_SOUND, type: types.CHECKBOX, value: soundChecked, styleClass: '' }
                        ].filter(item => !hideLangSelection || item.id !== actions.TOGGLE_LANG )"/>
        <settings-group :title="getTranslations.home_settings_others"
                        @select="onSelect"
                        :options="[
                          { name: getTranslations.home_profile_profile_edit_blocked_users, id: actions.BLOCK, type: types.TEXT, styleClass: 'icon' },
                          { name: userStatus, id: actions.SUB_RESUB, type: types.TEXT, styleClass: 'icon' },
                          { name: getTranslations.home_profile_edit_terms_and_conditions, id: actions.TERMS_AND_CONDITIONS, type: types.TEXT, styleClass: 'icon' },
                          { name: getTranslations.visitor_visitor_privacy_policy, id: actions.PRIVACY_POLICY, type: types.TEXT, styleClass: 'icon' }
                        ].filter(item => (!disableUnsubOption()) &&
                        !(existThisPathInForbiddenPages('/resubscribeSteps')
                        && !userDetails.subscribed)
                        && !(hasSubUnSubOption()) || item.id !== actions.SUB_RESUB)"/>
      </div>
    </section>
    <fade-transition>
      <component :is="modalForSettings" @close="storeModalForSettings(null)"/>
    </fade-transition>
  </div>
</template>

<script>
import FacebookLogin from '@/components/visitor/FacebookLogin';
import AvatarSelection from '@/components/home/profile/AvatarSelection';
import SettingsGroup from '@/components/home/profile/SettingsGroup';
import ChangeUsername from '@/components/home/modals/profile/ChangeUsername';
import Unsubscribe from '@/components/home/modals/Unsubscribe';
import UnsubscribeSms from '@/components/home/modals/UnsubscribeSms';
import ResubscribeRequestSettings from '@/components/home/modals/ResubscribeRequestSettings';
import ResubscribeQuestionViaSms from '@/components/home/modals/ResubscribeQuestionViaSms';
import ChangePin from '@/components/home/modals/profile/ChangePin';
import EmailSubmit from '@/components/home/modals/profile/EmailSubmit';
import RegistrationFlowMixin from '@/common/mixins/flow';
import FadeTransition from '@/components/home/modals/shared/FadeTransition';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  name: 'profile-edit',
  mixins: [RegistrationFlowMixin],
  components: {
    FacebookLogin,
    AvatarSelection,
    SettingsGroup,
    ChangePin,
    EmailSubmit,
    ChangeUsername,
    FadeTransition,
  },
  provide() {
    return {
      types: this.types,
    };
  },
  data() {
    return {
      types: {
        TEXT: 'text',
        SELECT: 'select',
        CHECKBOX: 'checkbox',
      },
      actions: {
        CHANGE_PIN: 'change-pin',
        CHANGE_USERNAME: 'change-username',
        EMAIL: 'email-submit',
        TOGGLE_VISIBILITY: 'toggle-visibility',
        TOGGLE_SOUND: 'sound',
        TOGGLE_LANG: 'change_lang',
        SUB_RESUB: 'sub-resub',
        BLOCK: 'block',
        TERMS_AND_CONDITIONS: 'terms-and-conditions',
        PRIVACY_POLICY: 'privacy-policy',
      },
      userStatus: null,
      editProfilePage: 'editProfile',
      soundChecked: true,
    };
  },
  created() {
    this.getUserStatusForSettingsMethod();
    this.$nextTick(() => {
      this.soundChecked = this.soundsOn;
    });
  },
  mounted() {
    this.setProfilePath(false);
  },
  updated() {
    this.getUserStatusForSettingsMethod();
  },
  beforeDestroy() {
    this.setProfilePath(true);
  },
  methods: {
    ...mapMutations('common', [
      'setProfilePath',
      'setSoundsOnOrOff',
      'storeModalForHomePage',
      'storeModalForSettings',
    ]),
    ...mapActions('common', [
      'sendAvatarCall',
      'updateDisplayAvatar',
      'sendFacebookImage',
      'facebookSDKApi',
    ]),
    ...mapMutations('i18n', [
      'setLocale',
      'updateActiveLocale',
    ]),
    ...mapActions('profile', [
      'storeAvailablePrizeTypes',
      'storeVisitorWinners',
      'changeVisibility',
    ]),
    ...mapActions('i18n', [
      'getLocaleAndTranslations',
      'updateUserLanguage',
    ]),
    isEligibleForPinChange() {
      return this.userDetails.hasPassword;
    },
    onSelect(action) {
      const {
        CHANGE_USERNAME,
        CHANGE_PIN,
        EMAIL,
        TOGGLE_SOUND,
        TOGGLE_LANG,
        BLOCK,
        TOGGLE_VISIBILITY,
        TERMS_AND_CONDITIONS,
        PRIVACY_POLICY,
      } = this.actions;

      switch (action.key) {
      case CHANGE_USERNAME: this.storeModalForSettings(ChangeUsername);
        break;
      case EMAIL: this.storeModalForSettings(EmailSubmit);
        break;
      case CHANGE_PIN: this.storeModalForSettings(ChangePin);
        break;
      case TOGGLE_VISIBILITY: this.changeVisibility();
        break;
      case TOGGLE_SOUND: this.updateSoundsStatus();
        break;
      case TOGGLE_LANG: this.updateAndStoreNewLanguageAndLocale(action.value.key, action.value.value);
        break;
      case BLOCK: this.$router.push({ name: 'blocked-users' });
        break;
      case TERMS_AND_CONDITIONS: window.open(this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_terms_and_conditions'), '_blank');
        break;
      case PRIVACY_POLICY: window.open(this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, 'project_privacy_and_policy'), '_blank');
        break;
      default: this.userChangeStatus();
        break;
      }
    },
    userChangeStatus() {
      // user is subscribed
      if (this.userDetails.subscribed) {
        if (this.subAndUnsubViaSMS) {
          if (this.reoptinAndOptoutConfig === 'OPTOUT_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS') {
            this.storeModalForSettings(UnsubscribeSms);
          } else {
            this.storeModalForHomePage(Unsubscribe);
          }
        } else {
          this.storeModalForSettings(Unsubscribe);
        }
      } else if (this.subAndUnsubViaSMS) {
        if (this.reoptinAndOptoutConfig === 'REOPTIN_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS') {
          this.storeModalForSettings(ResubscribeQuestionViaSms);
        } else {
          this.storeModalForHomePage(ResubscribeRequestSettings);
        }
      } else {
        this.storeModalForSettings(ResubscribeRequestSettings);
      }
    },
    getUserStatusForSettingsMethod() {
      if (!this.userDetails.subscribed) {
        this.userStatus = this.getTranslations.home_settings_resubscribe;
      } else {
        this.userStatus = this.getTranslations.home_settings_unsubscribe;
      }
    },
    updateSoundsStatus() {
      this.soundChecked = !this.soundChecked;
      this.setSoundsOnOrOff(this.soundChecked);
      localStorage.setItem('soundsOn', this.soundChecked);
    },
    updateAndStoreNewLanguageAndLocale(locale, localeIndex) {
      this.updateActiveLocale(localeIndex);
      localStorage.setItem('locale', locale);
      this.setLocale({ currentLocale: locale });
      this.updateUserLanguage().then(() => {
        this.getLocaleAndTranslations().then(() => {
          this.storeAvailablePrizeTypes(this.getLocale);
          this.facebookSDKApi().then(() => {
            this.storeVisitorWinners(this.getLocale);
          });
        });
      });
    },
  },
  computed: {
    ...mapState('i18n', [
      'localesMappedWithIndices',
    ]),
    ...mapState('common', [
      'userDetails',
      'soundsOn',
      'subAndUnsubViaSMS',
      'reoptinAndOptoutConfig',
      'modalForSettings',
      'hideLangSelection',
      'multiOperatorInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslationByOperator',
      'getTranslations',
    ]),
    ...mapGetters('common', [
      'existThisPathInForbiddenPages',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/profile/ProfileEdit.vue